import React, { useState, useEffect, useMemo } from 'react';
import { withRouter, useLocation, useHistory, useParams, Link } from 'react-router-dom';
import { Alert, Button, Container, Row, Col, Card, CardTitle, CardText, CardBody, CardFooter, CardHeader, Spinner } from "reactstrap";

import Form from "react-jsonschema-form";

import { http, notifier } from "common";

import { artisEventReqAssocAcceptInviteAPIPath } from "properties/config.json";


const ArtistEventReqAssocAcceptInvite = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [token, setToken] = useState();
  const [action, setAction] = useState();

  const [cardTitle, setCardTitle] = useState("");
  const [cardBody, setCardBody] = useState("");
  const [cardColor, setCardColor] = useState("info");

  const [progress, setProgress] = useState(true);

  const [errorStatus, setErrorStatus] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const action = queryParams.get('action');

    setToken(token);
    setAction(action);

    if ((token === undefined) || (action === undefined)) {
      setErrorStatus(true);
      setErrorMessage("Invalid URL");
    }
  }, []);

  useEffect(() => {
    setCardTitle(formCardTitle(action));
    setCardBody(formCardBody(action));
    setCardColor(formCardColor(action));

    setProgress(true);
    if ((token !== undefined) && (action !== undefined)) {
      sendApiRequest(token, action);
    }
  }, [action, token]);

  const formCardTitle = (title) => {
    switch(title) {
      case "accept":
	return "Accept Invite";
      case "reject":
	return "Reject Invite";
      default:
	return "Invalid Invite";
    }
  };

  const formCardBody = (title) => {
    switch(title) {
      case "accept":
	return "Accepting the invitation...";
      case "reject":
	return "Rejecting the invitation...";
      default:
	return "Invalid action";
    }
  };

  const formSuccessMessage = (title) => {
    switch(title) {
      case "accept":
	return "Accepting the invitation executed successfully";
      case "reject":
	return "Rejecting the invitation executed successfully";
      default:
	return "Invalid action";
    }
  };
  
  const formFailureMessage = (title) => {
    switch(title) {
      case "accept":
	return "Accepting the invitation failed.";
      case "reject":
	return "Rejecting the invitation failed.";
      default:
	return "Invalid action";
    }
  };

  const formCardColor = (title) => {
    switch(title) {
      case "accept":
	return "success";
      case "reject":
	return "danger";
      default:
	return "secondary";
    }
  };

  const sendApiRequest = (token, action) => {
    console.log(token);
    console.log(action);
    http
      .post(artisEventReqAssocAcceptInviteAPIPath, null, {params: { token: token, action: action }})
      .then((response) => {
        console.log(response);
        notifier.success("Action executed successfully");
	setProgress(false);
	setErrorStatus(response.data.errorStatus !== undefined ? response.data.errorStatus : false);
	setErrorMessage(response.data.logmessage);
      })
      .catch((error) => {
        console.log(error);
        notifier.error("Action execution failed");
	setProgress(false);
	setErrorStatus(true);
	setErrorMessage(formFailureMessage(action));
      });
  };

  return (
    <Container className="d-flex vh-100">
      <Row className="m-auto align-self-center">
        <Col>
          <Card color={cardColor} outline>
            <CardHeader>Invitation to Artist for an Event</CardHeader>
            <CardBody>
              <CardTitle></CardTitle>
              {(progress) ? (
                <CardText>{cardBody}</CardText>
	       ) : (
                 (errorStatus) ? (
		   <Alert color="danger"><small>{errorMessage}</small></Alert>
		 ) : (
		   <Alert color="success"><small>{errorMessage}</small></Alert>
		 )
	       )}
            </CardBody>
            <CardFooter>
             {(progress) ? (
              <Button
                color="primary"
                disabled
              >
                <Spinner size="sm">
                  In progress...
                </Spinner>
                <span>
                  {' '}In progress
                </span>
              </Button>
	      ) : (
              <Button color="primary" onClick={() => history.push('/login')}>Login</Button>
	      )}
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default withRouter(ArtistEventReqAssocAcceptInvite);
